import { useState } from 'react';
import UIComponentElement from '../templates/VystemLight/UIComponents/UIComponentElement';
import UiTemplateControl, { UiTemplateControlInterface } from './UiTemplateControl';

const TemplateControlWrapper = ({ component, ...controlProps }: Omit<UiTemplateControlInterface, 'updateShowControl'>) => {
  const [showControl, setShowControl] = useState(false);

  return (
    <UiTemplateControl {...controlProps} component={component} updateShowControl={setShowControl}>
      <UIComponentElement uiComponent={component as any} showControl={showControl} />
    </UiTemplateControl>
  );
};
export default TemplateControlWrapper;
